import React, {useRef} from 'react';
import Modal from 'jd-library/Modal';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import styles from './edit-product-modal.scss';
import Button from '../Button/Button';

const EditProductModal = props => {

	const inputRef = useRef(null);

	const getInputFields = () => {
		let inputlist = [];
		
		props.inputObj.forEach(inputField => {
			    inputlist.push(
					<InputWithMovingLabel
						label={inputField.label}
						holderClass={inputField.holderClass}
						input={inputField.input}
						ref = {inputRef}
						key={inputField.key}
						warning = {inputField.warning}
						errorMessage = {inputField.errorMessage}
					/>
				)
		});

		return inputlist;
	}
	return (
		<div className={styles['add-edit-block-modal']}>
			<Modal
				settings={{
					modalId: 'add-edit-modal',
					variant: 'action'
				}}
				onHidden={() => props.onModalClose()}
			>
				<Modal.CloseIcon />

				<Modal.Body>
					<div>
						<div className={styles['add-edit-title']}>
							  {props.title}
						</div>
						<div className={styles['add-edit-subtitle']}>
                            {props.subTitle}
						</div>
					</div>
				</Modal.Body>
			{
				 props.inputObj.length > 1 ?
				  <div className={styles['multiple-input-field']}>{getInputFields()}</div>
				  : getInputFields()
			  }

				<div className={styles['button-wrapper']}>
					<Button size='lg' clickHandler={props.onAddEditModalBtnClick} className={`${styles['misc-btn']} ${styles['no-hover']}`} showLoader={props.showLoader}>
						{props.buttonLabel}
					</Button>
				</div>
			</Modal>
		</div>
	);
};


export default EditProductModal;
